export interface NavigationLink {
    label: string
    href: string
    category?: string
    items?: NavigationLink[]
}

export type NavigationLinks = NavigationLink[]
export type NestedNavigationLinks = {
    [key: string]: NavigationLink[]
}

export const MAIN_NAVIGATION_LINKS: NavigationLinks = [
    {
        label: 'Benefits',
        href: '',
        items: [
            {
                label: 'Build Credit',
                href: '/build-credit',
            },
            {
                label: 'Save',
                href: '/save',
            },
            {
                label: 'Invest',
                href: '/investing',
            },
            {
                label: 'Earn Rewards',
                href: '/earn-rewards',
            },
            {
                label: 'Get Paid Early',
                href: '/direct-deposit',
            },
            // {
            //     label: 'Borrow',
            //     href: '/flex',
            // },
        ],
    },
    {
        label: 'For Parents',
        href: '/for-parents',
        items: [
            {
                label: 'Overview',
                href: '/for-parents',
            },
            {
                label: 'Credit History',
                href: '/credit-history',
            },
            {
                label: 'Savings',
                href: '/savings',
            },
            {
                label: 'Allowance',
                href: '/allowance',
            },
            {
                label: 'Rewards',
                href: '/rewards',
            },
            {
                label: 'Convenience',
                href: '/convenience',
            },
            {
                label: 'Investing',
                href: '/investing-for-parents',
            },
        ],
    },
    {
        label: 'Money 101',
        href: '/education',
    },
    {
        label: 'Step Black',
        href: '/blackcard',
    },
    {
        label: 'Security',
        href: '/security',
    },
    {
        label: 'About',
        href: '/about',
    },
    {
        label: 'FAQ',
        href: '/faq',
    },
]

export const FOOTER_NAVIGATION_LINKS: NavigationLinks = [
    // Company
    {
        label: 'About',
        href: '/about',
        category: 'Company',
    },
    {
        label: 'Careers',
        href: '/careers',
        category: 'Company',
    },
    {
        label: 'Press',
        href: '/press',
        category: 'Company',
    },
    {
        label: 'Money 101 Blog',
        href: '/money-101',
        category: 'Company',
    },
    {
        label: 'Step Merch Store',
        href: 'https://shop.step.com',
        category: 'Company',
    },
    // Legal
    {
        label: 'Policies',
        href: '/policies',
        category: 'Legal',
    },
    {
        label: 'Privacy Policy',
        href: '/policies/privacy',
        category: 'Legal',
    },
    {
        label: 'COPPA',
        href: '/policies/coppa',
        category: 'Legal',
    },
    {
        label: 'Cookie Declaration',
        href: '/cookie-declaration',
        category: 'Legal',
    },
    // Support
    {
        label: 'FAQ',
        href: '/faq',
        category: 'Support',
    },
    {
        label: 'Contact Us',
        href: 'mailto:hello@step.com',
        category: 'Support',
    },
    {
        label: 'Partner With Us',
        href: '/partners',
        category: 'Support',
    },
    {
        label: 'Status',
        href: 'https://status.step.com/',
        category: 'Support',
    },
]
